// import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Calendar as CalendarAD } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { ToggleButton } from "primereact/togglebutton";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { calculateAge } from "../../helper/helper";
import {
  setDistrictList,
  setDocumentTypeList,
  setDocumentValue,
  setSpecificDocument,
} from "../../redux/documentSlice";
import { setSectionDynamicFieldList } from "../../redux/dynamicFieldSlice";
import {
  setDob,
  setDobAndMinor,
  setDobBs,
  setDocumentForMinor,
  setFirstName,
  setFirstNameError,
  setFirstNameNep,
  setGender,
  setIsDisabled,
  setIssuedDate,
  setIssuedDateBs,
  setLastName,
  setLastNameError,
  setLastNameNep,
  setMaritalStatus,
  setMiddleName,
  setMiddleNameError,
  setMiddleNameNep,
  setNationality,
  setNationalityDesc,
  setNrn,
  setPan
} from "../../redux/personSlice";
import { disableSection } from "../../redux/routerSlice";
import configureStore from "../../redux/store";
import { DynamicInputField } from "../input/DynamicInputField";
import InputText from "../other/InputText";
import AdBsDatePicker from "../other/adBsDatePicker";
import FileUploadComponent from "../other/fileUploadComponent";
import { getTValue } from "../other/label";
import ApiService from "../service/apiService";
import { SaveButton } from "./declerationDetails";
import { filterDocument, PERSON_DETAIL_DOCUMENT } from "./documentDetails";
import { NextButton } from "./kycSidebar";

import PanComparisionComponent from "../other/panComparisionComponent";
import { validateNameField } from "../../helper/validationHelper";

function isValidDate(date) {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if (!date.match(regEx)) return false; // Invalid format
  var d = new Date(date);
  var dNum = d.getTime();
  if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0, 10) === date;
}

function PersonalDetails(props) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const firstName = useSelector((state) => state.personalDetails.firstName);
  const lastName = useSelector((state) => state.personalDetails.lastName);
  const firstNameError = useSelector((state) => state.personalDetails.errors.firstNameError);
  const middleNameError = useSelector((state) => state.personalDetails.errors.middleNameError);
  const lastNameError = useSelector((state) => state.personalDetails.errors.lastNameError);
  const middleName = useSelector((state) => state.personalDetails.middleName);
  const firstNameNep = useSelector(
    (state) => state.personalDetails.firstNameNep
  );
  const lastNameNep = useSelector((state) => state.personalDetails.lastNameNep);
  const middleNameNep = useSelector(
    (state) => state.personalDetails.middleNameNep
  );
  const dob = useSelector((state) => state.personalDetails.dob);
  const dobBs = useSelector((state) => state.personalDetails.dobBs);

  const isMinor = useSelector((state) => state.personalDetails.isMinor);
  const isNrn = useSelector((state) => state.personalDetails.isNrn);
  const gender = useSelector((state) => state.personalDetails.gender);
  const nationality = useSelector((state) => state.personalDetails.nationality);
  const isDisabled = useSelector(state => state.personalDetails.isDisabled);
  const maritalStatus = useSelector(state => state.personalDetails.maritalStatus);

  const locationType = useSelector(
    (state) => state.addressDetails.locationType
  );
  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const documentType = documentTypeList.find((d) => d.code === "PH") || {};
  const documentList = useSelector(
    (state) => state.documentDetails.documentList
  );
  const nationalityDesc = useSelector(
    (state) => state.personalDetails.nationalityDesc
  );
  const pan = useSelector((state) => state.personalDetails.pan);
  const nrnId = useSelector((state) => state.personalDetails.nrnId);
  const nrnAddress = useSelector((state) => state.personalDetails.nrnAddress);
  const citizenshipNo = useSelector(
    (state) => state.personalDetails.citizenshipNo
  );
  const issuedDistrict = useSelector(
    (state) => state.personalDetails.issuedDistrict
  );
  const issuedDate = useSelector((state) => state.personalDetails.issuedDate);
  const issuedDateBs = useSelector(
    (state) => state.personalDetails.issuedDateBs
  );
  const formType = useSelector((state) => state.routerData.formType);
  const criticalDataChanged = useSelector((state) => state.routerData.criticalDataChanged);
  const nationalId = useSelector((state) => state.personalDetails.nationalId);
  const passportNo = useSelector((state) => state.personalDetails.passportNo);
  const expiryDate = useSelector((state) => state.personalDetails.expiryDate);
  const documentForMinor = useSelector(
    (state) => state.personalDetails.documentForMinor
  );
  const [dateError, setDateError] = useState();
  const [loadingc, setLoadingc] = useState(false);

  const errorObj = useSelector((state) => state.personalDetails.errors);
  let {
    // firstNameError,
    // middleNameError,
    // lastNameError,
    firstNameNepError,
    lastNameNepError,
    dobError,
    genderError,
    nationalityError,
    panError,
  } = {};

  // if (errorObj && errorObj.firstNameError) {
  //   firstNameError = errorObj.firstNameError.message;
  // }
  // if (errorObj && errorObj.middleNameError) {
  //   middleNameError = errorObj.middleNameError.message;
  // }
  // if (errorObj && errorObj.lastNameError) {
  //   lastNameError = errorObj.lastNameError.message;
  // }
  if (errorObj && errorObj.firstNameNepError) {
    firstNameNepError = errorObj.firstNameNepError.message;
  }
  if (errorObj && errorObj.lastNameNepError) {
    lastNameNepError = errorObj.lastNameNepError.message;
  }
  if (errorObj && errorObj.dobError) {
    dobError = errorObj.dobError.message;
  }
  if (errorObj && errorObj.genderError) {
    genderError = errorObj.genderError.message;
  }
  if (errorObj && errorObj.nationalityError) {
    nationalityError = errorObj.nationalityError.message;
  }
  if (errorObj && errorObj.panError) {
    panError = errorObj.panError.message;
  }

  const photoErrorObj = useSelector((state) => state.documentDetails.errors);
  let photoError = "";

  if (photoErrorObj && photoErrorObj.PHDocumentError) {
    photoError = photoErrorObj.PHDocumentError.message;
  }

  const dispatch = useDispatch();

  const [nationalityList, setNationalityList] = useState([]);
  const districtList = useSelector(
    (state) => state.documentDetails.districtList
  );

  useEffect(() => {
    if (!documentTypeList.length)
      ApiService.getDocumentTypeList().then((response) => {
        dispatch(setDocumentTypeList(response.data.data));
      });
  }, []);

  useEffect(() => {
    setLoadingc(true);
    ApiService.getNationalityList().then((response) => {
      console.log(response);
      setNationalityList(response.data);
    }).finally(() => setLoadingc(false));

    ApiService.getDocumentTypeList().then((response) => {
      setDocumentTypeList(response.data.data);
    });

    if (!districtList.length)
      ApiService.getDistrictList().then((response) => {
        dispatch(setDistrictList(response.data.data));
      });
  }, []);

  const handleDate = ({ bsDate, adDate }) => {
    dispatch(setIssuedDateBs(bsDate));
    dispatch(setIssuedDate(new Date(adDate)));
  };

  const handleDobDate = ({ bsDate, adDate }) => {
    dispatch(setDobBs(bsDate));
    dispatch(setDob(adDate));
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    console.log("trryyy", name);
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const onSubmit = () => {
    const data = configureStore.getState();
    console.log("form data", data);
  };

  const photo = documentList.find((d) => d.documentTypeId === "PH") || {};

  const [kycPan, setKycPan] = useState({});
  const [panDetailsModal, setPanDetailsModal] = useState(false);

  const isCritcalChanged = (name) => {
    if (criticalDataChanged) {
      const arr = criticalDataChanged.split(",");
      if (arr.includes(name)) {
        return true;
      }
      else return false;
    }
  };
  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-user" /> {t("Personal Information")}
        </h3>
      }
      footer={
        <div class=" p-field p-col-12 p-md-12">
          <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
            <div style={{ flex: 1 }}></div>
            <div style={{ flex: 1 }}>
              <center>
                <SaveButton style={{ flex: 1 }} />
              </center>
            </div>
            <div style={{ flex: 1 }}>
              <NextButton className="p-next-button" />
            </div>
          </div>
        </div>
      }
    >
      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div className="p-field p-col-12 p-md-12" >
          <FileUploadComponent
            data={{ ...photo, ...documentType }}
            type="userPhoto"
            onUpload={(data) => {
              dispatch(
                setSpecificDocument({
                  documentTypeCode: 13,
                  documentTypeId: "PH",
                  fileId: data.storageFileName,
                })
              );
            }}
          />

        </div>
        <span style={{ color: "red", marginLeft: 370 }}>{photoError}</span>
        <h4 className="p-col-12 p-md-12">
          <p className="section-title">{t("basicInfo")}</p>
        </h4>
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="nameEng">
            {t("nameEnglish")}*
          </label>
          <div className="p-inputgroup">
            {/* <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  placeholder={t("fName")}
                  keyfilter="alpha"
                  isName
                  onChange={(e) => {
                    dispatch(setFirstName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  value={firstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            {getFormErrorMessage("firstName")} */}
            <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  placeholder={t("fName")}
                  keyfilter={/^[a-zA-Z .]*$/}
                  isName
                  onChange={(e) => {
                    dispatch(setFirstName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    // Use dynamic validation helper for firstName
                    validateNameField(e.target.value, "First Name", dispatch, setFirstNameError, setFirstNameError, firstName, "Valid First Name is required");
                  }}
                  value={firstName}
                  className={classNames({
                    //  "p-invalid": fieldState.invalid 
                    // "p-invalid": fieldState.invalid || firstNameError,
                    "p-invalid": fieldState.invalid || firstNameError?.message,
                  })}
                  disabled={isCritcalChanged("NAME")}
                />
              )}
            />
            {getFormErrorMessage("firstName")}
            {/* <Controller
              name="middleName"
              control={control}
              rules={{ required: "Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z ]*$/}
                  placeholder={t("mName")}
                  onChange={(e) => {
                    dispatch(setMiddleName(e.target.value));

                    field.onChange(e.target.value);
                  }}
                  value={middleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            {getFormErrorMessage("middleName")} */}
            <Controller
              name="middleName"
              control={control}
              rules={{ required: "Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("mName")}
                  onChange={(e) => {
                    dispatch(setMiddleName(e.target.value));

                    field.onChange(e.target.value);
                  }}
                  // value={middleName}
                  // className={classNames({ "p-invalid": fieldState.invalid })}
                  onBlur={(e) => {
                    validateNameField(e.target.value, "Middle Name", dispatch, setMiddleNameError, setMiddleNameError, middleName, "Valid Middle Name is required");
                  }}
                  value={middleName}
                  className={classNames({
                    "p-invalid": fieldState.invalid || middleNameError?.message,
                  })}
                  disabled={isCritcalChanged("NAME")}
                />
              )}
            />
            {getFormErrorMessage("middleName")}
            {/* <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => {
                    dispatch(setLastName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  value={lastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            {getFormErrorMessage("lastName")} */}
            <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => {
                    dispatch(setLastName(e.target.value));
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    // Use dynamic validation helper for lastName
                    validateNameField(e.target.value, "Last Name", dispatch, setLastNameError, setLastNameError, lastName, "Valid Last Name is required");
                  }}
                  value={lastName}
                  className={classNames({
                    // "p-invalid": fieldState.invalid
                    "p-invalid": fieldState.invalid || lastNameError?.message,
                  })}
                  disabled={isCritcalChanged("NAME")}
                />
              )}
            />
            {getFormErrorMessage("lastName")}
          </div>
          {/* <span style={{ color: "red" }}>{firstNameError?.message}</span>
          {firstNameError && middleNameError && lastNameError && <br />}
          <span style={{ color: "red" }}>{middleNameError?.message}</span>
          <span style={{ color: "red" }}>{lastNameError?.message}</span> */}
          <span style={{ color: "red" }}>{firstNameError?.message}</span>
          <span style={{ color: "red", marginLeft: "13%" }}>{middleNameError?.message}</span>
          <span style={{ color: "red", marginLeft: "10%" }}>{lastNameError?.message}</span>
        </div>
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="nameNep">
            {t("nameNepali")}*
          </label>
          <div className="p-inputgroup">
            <InputText
              placeholder={t("fName")}
              value={firstNameNep}
              keyfilter="alpha"
              convertToNepali
              onChange={(e) => {
                dispatch(setFirstNameNep(e.value));
              }}
              disabled={isCritcalChanged("NAME")}
            />
            <InputText
              placeholder={t("mName")}
              isName
              keyfilter={/^[a-zA-Z ]*$/}
              value={middleNameNep}
              convertToNepali
              onChange={(e) => {
                dispatch(setMiddleNameNep(e.value));
              }}
              disabled={isCritcalChanged("NAME")}
            />
            <InputText
              placeholder={t("lName")}
              value={lastNameNep}
              keyfilter={/^[a-zA-Z .]*$/}
              isName
              convertToNepali
              onChange={(e) => {
                dispatch(setLastNameNep(e.value));
              }}
              disabled={isCritcalChanged("NAME")}
            />
          </div>
          <span style={{ color: "red" }}>{firstNameNepError}</span>
          {firstNameNepError && lastNameNepError && <br />}
          <span style={{ color: "red" }}>{lastNameNepError}</span>
        </div>
        {getFormErrorMessage("firstNameNep")}
        {getFormErrorMessage("middleNameNep")}
        {getFormErrorMessage("lastNameNep")}

        <Controller
          name="dateOfBirth"
          control={control}
          rules={{
            required: "Date of Birth is required.",
          }}
          render={({ field, fieldState }) => (
            <AdBsDatePicker
              label={t("dateOfBirth")}
              bsDate={dobBs}
              adDate={dob}
              adError={dobError}
              getFormErrorMessageAd={getFormErrorMessage('dateInAd')}
              getFormErrorMessageBs={getFormErrorMessage('dateInBs')}
              onChange={(adDate, bsDate, extra) => {

                field.onChange(
                  adDate
                ); const isMinor = calculateAge(new Date(adDate)) < 18;
                const nAdDate = { date: adDate, isMinor };
                dispatch(setDobAndMinor(nAdDate));
                const nExtra = { code: "GD", flag: !isMinor };
                dispatch(disableSection(nExtra));
                dispatch(setDobBs(bsDate));
              }}

              disabled={isCritcalChanged("NAME")} />
          )}
        />
        {/* <div className="p-field p-col-12 p-md-4 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="dobBs">
            {t("dateOfBirth")}{t("bs")}*
          </label>
          <span className="p-input-icon-right">
            <i className="pi pi-calendar icon-front" />
            <NepaliDatePicker2
              inputClassName={"form-control p-inputtext p-component p-filled"}
              placeholder={t("dateInBs")}
              onChange={(value) => {
                dispatch(setDobBs(value));
                const checkDate = isValidDate(value);
                let date;
                try {
                  date = bsToAd(value);
                  console.log("BSDATE", date);
                  if (new Date(date) > new Date())
                    setDateError("Future date not allowed");
                  else setDateError("");
                } catch (e) { }
                if (checkDate && date) {
                  const isMinor = calculateAge(new Date(date)) < 18;

                  dispatch(setDobAndMinor({ date: new Date(date), isMinor }));
                  dispatch(disableSection({ code: "GD", flag: !isMinor }));
                }
              }}
              value={dobBs}
            />
          </span>
          <span style={{ color: "red" }}>{dateError}</span>
        </div>

        {getFormErrorMessage("dateInBs")}
        <div className="p-field p-col-12 p-md-4 stick-left  stick-right">
          <label className="p-col-12 p-md-12" htmlFor="dob">
            {t("dateOfBirth")}{t("ad")}*
          </label>

          <span className="p-input-icon-right">
            <i className="pi pi-calendar icon-front" />

            <Controller
              name="dateOfBirth"
              control={control}
              rules={{
                required: "Date of Birth is required.",
              }}
              render={({ field, fieldState }) => (
                <CalendarAD
                  mask="9999-99-99"
                  id={field.name}
                  {...field}
                  placeholder={t("dateInAd")}
                  //readOnlyInput
                  value={dob}
                  onChange={(e) => {
                    if (!e.value) { return; }
                    try {

                      const date = e.value;
                      if (date) {
                        // const convertedAdDate = adToBs(
                        //   date.toISOString().split("T")[0]
                        // );
                        const convertedAdDate = adToBs(
                          new Date(
                            date.getTime() - date.getTimezoneOffset() * 60000
                          )
                            .toISOString()
                            .split("T")[0]
                        );

                        field.onChange(date.toISOString().split("T")[0]);
                        const isMinor = calculateAge(new Date(date)) < 18;
                        dispatch(setDobAndMinor({ date: new Date(date + "EDT"), isMinor }));
                        dispatch(disableSection({ code: "GD", flag: !isMinor }));
                        dispatch(setDobBs(convertedAdDate));
                      }
                    } catch (e) {
                      alert("Date out of availability");
                      console.log(e);
                    }
                  }}
                  monthNavigator
                  yearNavigator
                  yearRange={"1900 : " + new Date().getFullYear()}
                  dateFormat="yy-mm-dd"
                  maxDate={new Date()}
                />
              )}
            />
          </span>
          <span style={{ color: "red" }}>{dobError}</span>
        </div>
        {getFormErrorMessage("dateInAd")} */}

        <div className="p-field p-col-12 p-md-4 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="isMinor">
            {t("minorDetails")}
          </label>
          <ToggleButton
            style={{ borderRadius: 0, background: "#d9dfe5" }}
            onIcon="pi pi-check"
            checked={isMinor}
            onLabel={t("iamminor")}
            offLabel={t("iamnotMinor")}
            offIcon="pi pi-times"
          />
        </div>

        <div className="p-field p-col-12 p-md-5 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="gender">
            {t("gender")}*
          </label>
          <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
            <RadioButton
              name="gender"
              inputId="gender"
              Male
              value={"M"}
              onChange={(e) => dispatch(setGender(e.value))}
              checked={gender === "M"}
            />
            <label className="p-mr-5" htmlFor="male">
              {t("male")}
            </label>
            <RadioButton
              name="gender"
              inputId="genderFemale"
              value={"F"}
              onChange={(e) => dispatch(setGender(e.value))}
              checked={gender === "F"}
            />
            <label className="p-mr-5" htmlFor="female">
              {" "}
              {t("female")}
            </label>
            <RadioButton
              name="gender"
              inputId="genderOther"
              value={"O"}
              onChange={(e) => dispatch(setGender(e.value))}
              checked={gender === "O"}
            />
            <label htmlFor="other">{t("other")}</label>
          </div>
          <span style={{ color: "red" }}>{genderError}</span>
        </div>
        {getFormErrorMessage("gender")}
        <div className="p-field p-col-12 p-md-5 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="nationality">
            {t("nationality")}*
          </label>
          <Controller
            name="nationality"
            control={control}
            rules={{ required: "Nationality is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={nationality}
                filter showClear
                disabled={loadingc}
                dropdownIcon={loadingc ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}

                onChange={(e) => {
                  console.log(e.originalEvent.nativeEvent.target.ariaLabel);
                  field.onChange(e.value);
                  dispatch(setNationality(e.value));
                  dispatch(
                    setNationalityDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                  //  dispatch(setNationalityDesc(setDropdownDesc(nationalityList,e.value)));
                }}
                options={nationalityList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectNationality")}
                optionValue={"code"}
              />
            )}
          />
          <span style={{ color: "red" }}>{nationalityError}</span>
        </div>
        {getFormErrorMessage("nationality")}

        <div className="p-field p-col-12 p-md-2 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="pan">
            {t("pan")}
          </label>
          <InputMask
            value={pan}
            onChange={(e) => {
              dispatch(setPan(e.target.value));
            }} onBlur={() => {
              {
                setPanDetailsModal(pan)
                console.log("KycPan", kycPan);
                // console.log("data",user,kyc);             
              }
            }}
            mask="999999999"
            placeholder={t("pan")}
          />
        </div>
        <span style={{ color: "red" }}>{panError}</span>
        {getFormErrorMessage("pan")}
        {nationality == "NP" && (
          <>
            <div className="p-field p-col-12 p-md-3 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="nrn">
                {t("nrn")}
              </label>
              <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
                <RadioButton
                  name="isNrn"
                  inputId="isNrnYes"
                  value={true}
                  onChange={(e) => dispatch(setNrn(e.value))}
                  checked={isNrn}
                />
                <label className="p-mr-5" htmlFor="isNrnYes">
                  {" "}
                  {t("yes")}
                </label>
                <RadioButton
                  name="isNrn"
                  inputId="isNrnNo"
                  value={false}
                  onChange={(e) => dispatch(setNrn(e.value))}
                  checked={!isNrn}
                />
                <label className="p-mr-5" htmlFor="isNrnNo">
                  {" "}
                  {t("no")}
                </label>
              </div>
            </div>
          </>
        )}
        {getFormErrorMessage("isNrn")}
        <div className="p-field p-col-12 p-md-5 stick-right stick-left">
          <label className="p-col-12 p-md-12" htmlFor="maritialStatus">
            {t("maritalStatus")}
          </label>
          <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
            <RadioButton
              name="isMarride"
              inputId="isMarriedYes"
              value={"M"}
              onChange={(e) => dispatch(setMaritalStatus(e.value))}
              checked={maritalStatus === "M"}
            />
            <label className="p-mr-5" htmlFor="isNrnYes">
              {" "}
              {t("married")}
            </label>
            <RadioButton
              name="isMarride"
              inputId="isMarride"
              value={"UM"}
              onChange={(e) => dispatch(setMaritalStatus(e.value))}
              checked={maritalStatus == "UM"}
            />
            <label className="p-mr-5" htmlFor="isNrnNo">
              {" "}
              {t("unmarried")}
            </label>

            <RadioButton
              name="isMarride"
              inputId="isMarride"
              value={"O"}
              onChange={(e) => dispatch(setMaritalStatus(e.value))}
              checked={maritalStatus == "O"}
            />
            <label className="p-mr-5" htmlFor="isMarride">
              {" "}
              {t("other")}
            </label>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-4 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="maritialStatus">
            {t("isDisabled")}
          </label>
          <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
            <RadioButton
              name="isMarried"
              inputId="isMarriedYes"
              value={true}
              onChange={(e) => dispatch(setIsDisabled(e.value))}
              checked={isDisabled}
            />
            <label className="p-mr-5" htmlFor="isNrnYes">
              {" "}
              {t("yes")}
            </label>
            <RadioButton
              name="isNrn"
              inputId="isNrnNo"
              value={false}
              onChange={(e) => dispatch(setIsDisabled(e.value))}
              checked={!isDisabled}
            />
            <label className="p-mr-5" htmlFor="isNrnNo">
              {" "}
              {t("no")}
            </label>
          </div>
        </div>

        {isMinor && (
          <>
            <div className="p-field p-col-12 p-md-5 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="docType">
                {t("minorDocument")}
              </label>
              <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
                <RadioButton
                  name="citizenship"
                  value={"CZ"}
                  onChange={(e) => dispatch(setDocumentForMinor(e.value))}
                  checked={documentForMinor === "CZ"}
                />
                <label className="p-mr-5" htmlFor="birthCertificate">
                  {t("citizenship")}
                </label>
                <RadioButton
                  name="citizenship"
                  value={"BC"}
                  onChange={(e) => dispatch(setDocumentForMinor(e.value))}
                  checked={documentForMinor === "BC"}
                />
                <label className="p-mr-5" htmlFor="birthCertificate">
                  {t("birthCertificate")}
                </label>
              </div>
            </div>
          </>
        )}

        {documentList
          .filter(
            (p) =>
              PERSON_DETAIL_DOCUMENT.includes(p.documentTypeId) &&
              filterDocument(p, {
                nationality,
                isMinor,
                isNrn,
                documentForMinor,
                locationType,
              })
          )
          .map((p) => {
            switch (p.documentTypeId) {
              case "CZ":
                return <CitizenshipComponent data={p} />;
              case "NR":
                return <NrnComponent data={p} />;
              case "PP":
                return <PassportComponent data={p} />;
              case "NI":
                return <NationalIdComponent data={p} />;
              default:
                return <DefaultDocumentComponent data={p} />;
            }
          })}
        <DynamicFieldSection />
      </div>
      {panDetailsModal && <PanComparisionComponent pan={pan} setShowModal={setPanDetailsModal}
        otherDetails={[
          { title: "Name", data: (firstName + " " + (middleName ? middleName : "") + " " + lastName), data1: kycPan.tradeNameEnglish },
          { title: "Name Nepali", data: (firstNameNep + " " + (middleNameNep ? middleNameNep : "") + " " + lastNameNep), data1: kycPan.tradeNameNepali },
        ]} setParentKycPan={setKycPan} />}
    </Card>
  );
}

export function DynamicFieldSection() {
  const sectionDynamicFieldList = useSelector(
    (state) => state.dynamicFieldDetails.sectionDynamicFieldList
  );

  const activeSectionId = useSelector(
    (state) => state.routerData.activeSectionId
  );

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeSectionId) {
      dispatch(setSectionDynamicFieldList(activeSectionId));
    }
  }, [activeSectionId]);

  const gridList = sectionDynamicFieldList.reduce((a, v) => {
    a[v.gridRow || '999'] = [...(a[v.gridRow || '999'] || []), v];
    return a;
  }, {});

  if (sectionDynamicFieldList && sectionDynamicFieldList.length)
    return (
      <>
        <div className="p-col-12 p-md-12 p-field">
          {Object.keys(gridList).sort((v1, v2) => v1 - v2).map((k) => {
            const dynamicFieldList = gridList[k].sort((v1, v2) => (v1.order || 999) - (v2.order || 999));
            return <div className="p-grid p-fluid p-field p-col-12 p-md-12" style={{ margin: 0 }}>
              {dynamicFieldList.map(dynamicField => <div className={" stick-left stick-right p-field p-col-12 p-md-" + (dynamicField.gridSize || 4)}><DynamicInputField metaData={dynamicField} /></div>)}
            </div>;
          })}
        </div>
      </>
    );
  else return null;
}

function NrnComponent({ data }) {
  const { t } = useTranslation();
  const nrnIdError = useSelector((state) => state.personalDetails.nrnIdError);
  const nrnAddressError = useSelector(
    (state) => state.personalDetails.nrnAddressError
  );
  const dispatch = useDispatch();

  return (
    <>
      <h4 className="p-col-12 p-md-12">
        <p className="section-title">{t("NRN")}</p>
      </h4>
      <div className="p-field p-col-12 p-md-6 stick-right">
        <label className="p-col-12 p-md-12" htmlFor="nrnId">
          {t("nrnId")}
        </label>
        <InputText
          value={data.docId}
          onChange={(e) => {
            dispatch(
              setDocumentValue({
                code: "NR",
                key: "docId",
                value: e.target.value,
              })
            );
          }}
          placeholder={t("nrnId")}
        />
      </div>
      <div className="p-field p-col-12 p-md-6 stick-left">
        <label className="p-col-12 p-md-12" htmlFor="nrnAddress">
          {t("nrnAddress")}
        </label>
        <InputText
          value={data.issuedFrom}
          onChange={(e) => {
            dispatch(
              setDocumentValue({
                code: "NR",
                key: "issuedFrom",
                value: e.target.value,
              })
            );
          }}
          placeholder={t("nrnAddress")}
        />
      </div>
      {data.errorDesc && <span style={{ color: "red" }}>{data.errorDesc}</span>}
      <span style={{ color: "red" }}>{nrnIdError}</span>
      <span style={{ color: "red", marginLeft: 350 }}>{nrnAddressError}</span>
    </>
  );
}

function PassportComponent({ data }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  return (
    <>
      <h4 className="p-col-12 p-md-12">
        <p className="section-title">{t("passport")}</p>
      </h4>
      <div className="p-field p-col-12 p-md-6 stick-right">
        <label className="p-col-12 p-md-12" htmlFor="passportNo">
          {t("passportNo")}
        </label>
        <InputText
          placeholder={t("passportNo")}
          value={data.docId}
          onChange={(e) => {
            dispatch(
              setDocumentValue({
                code: "PP",
                key: "docId",
                value: e.target.value,
              })
            );
          }}
        />
      </div>
      <div className="p-field p-col-12 p-md-6 stick-left stick-right">
        <label className="p-col-12 p-md-12" htmlFor="expiryDate">
          {t("expiryDate")}
        </label>
        <span className="p-input-icon-right">
          <i className="pi pi-calendar icon-front" />
          <CalendarAD
            mask="9999-99-99"
            value={data.issuedDate}
            onChange={(e) =>
              dispatch(
                setDocumentValue({
                  code: "PP",
                  key: "issuedDate",
                  value: new Date(e.target.value + "EDT"),
                })
              )
            }
            placeholder={t("expiryDate")}
            monthNavigator
            yearNavigator
            yearRange={"1900 : " + new Date().getFullYear()}
            dateFormat="yy-mm-dd"
          />
        </span>
      </div>
      {data.errorDesc && <span style={{ color: "red" }}>{data.errorDesc}</span>}
    </>
  );
}

function NationalIdComponent({ data }) {
  const { t } = useTranslation();
  return (
    <DefaultDocumentComponent
      data={{ ...data, metaData: { docId: t("nationalId") } }}
    />
  );
}

function CitizenshipComponent({ data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const districtList = useSelector(
    (state) => state.documentDetails.districtList
  );
  const citizenshipNoError = useSelector(
    (state) => state.personalDetails.citizenshipNoError
  );
  const issuedDistrictError = useSelector(
    (state) => state.personalDetails.issuedDistrictError
  );
  const issuedDateError = useSelector(
    (state) => state.personalDetails.issuedDateError
  );

  return (
    <>
      <h4 className="p-col-12 p-md-12">
        <p className="section-title">{t("citizenship")}</p>
      </h4>
      <div className="p-field p-col-12 p-md-3 stick-right">
        <label className="p-col-12 p-md-12" htmlFor="citizenshipNo">
          {t("citizenshipNo")}
        </label>
        <InputText
          value={data.docId}
          onChange={(e) => {
            dispatch(
              setDocumentValue({
                code: "CZ",
                key: "docId",
                value: e.target.value,
              })
            );
          }}
          placeholder={t("citizenshipNo")}
        />
      </div>
      <div className="p-field p-col-12 p-md-3 stick-left stick-right">
        <label className="p-col-12 p-md-12" htmlFor="issuedDistrict">
          {t("issuedDistrict")}
        </label>
        <Dropdown
          value={data.issuedFrom}
          onChange={(e) => {
            dispatch(
              setDocumentValue({
                code: "CZ",
                key: "issuedFrom",
                value: e.target.value,
              })
            );
            dispatch(
              setDocumentValue({
                code: "CZ",
                key: "issuedFromDesc",
                value: e.originalEvent.nativeEvent.target.ariaLabel,
              })
            );
          }}
          options={districtList}
          optionLabel="descEng"
          placeholder={t("selectDistrict")}
          optionValue="code"
        />
      </div>

      <AdBsDatePicker
        label={t("dateIn")}
        bsDate={data.issuedDateBs}
        adDate={data.issuedDate}
        onChange={(issuedDate, issuedDateBs, extra) => {
          dispatch(
            setDocumentValue({ code: "CZ", key: "issuedDateBs", issuedDateBs })
          );
          dispatch(setDocumentValue({
            code: "CZ",
            key: "issuedDate",
            value: issuedDate,
          }))
        }} />



      {/* <div className="p-field p-col-12 p-md-3 stick-left stick-right">
        <label className="p-col-12 p-md-12" htmlFor="issuedDateBs">
          {t("dateInBs")}
        </label>
        <span className="p-input-icon-right">
          <i className="pi pi-calendar icon-front" />
          <NepaliDatePicker2
            inputClassName="form-control p-inputtext p-component p-filled"
            value={data.issuedDateBs}
            onChange={(value) => {
              dispatch(
                setDocumentValue({ code: "CZ", key: "issuedDateBs", value })
              );

              const checkDate = isValidDate(value);
              if (checkDate) {
                const convertedBsDate = bsToAd(value);
                dispatch(
                  setDocumentValue({
                    code: "CZ",
                    key: "issuedDate",
                    value: new Date(convertedBsDate),
                  })
                );
              }
            }}
          />
        </span>
      </div>
      <div className="p-field p-col-12 p-md-3 stick-left stick-right">
        <label className="p-col-12 p-md-12" htmlFor="issuedDate">
          {t("dateInAd")}
        </label>
        <span className="p-input-icon-right">
          <i className="pi pi-calendar icon-front" />
          <CalendarAD
            mask="9999-99-99"
            value={data.issuedDate}
            onChange={(e) => {
              if (!e.value) { return; }
              try {

                const convertedAdDate = adToBs(
                  new Date(
                    e.value.getTime() - e.value.getTimezoneOffset() * 60000
                  )
                    .toISOString()
                    .split("T")[0]
                );
                dispatch(
                  setDocumentValue({
                    code: "CZ",
                    key: "issuedDateBs",
                    value: convertedAdDate,
                  })
                );
                dispatch(
                  setDocumentValue({
                    code: "CZ",
                    key: "issuedDate",
                    value: new Date(e.value + "EDT"),
                  })
                );

              } catch (e) {
                alert("Date out of availability");
                console.log(e);
              }
            }}
            placeholder={t("dateInAd")}
            monthNavigator
            yearNavigator
            yearRange={"1900 : " + new Date().getFullYear()}
            dateFormat="yy-mm-dd"
          />
        </span>
      </div> */}
      {data.errorDesc && <span style={{ color: "red" }}>{data.errorDesc}</span>}
      <span style={{ color: "red", marginLeft: 20 }}>
        {issuedDistrictError}
      </span>
      <span style={{ color: "red", marginLeft: 50 }}>{issuedDateError}</span>
    </>
  );
}

export function DefaultDocumentComponent({ data }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const metaData = data.metaData
    ? {
      docId:
        data.metaData.docId && data.metaData.docId.descEng
          ? getTValue(
            i18n,
            data.metaData.docId.descEng,
            data.metaData.docId.descNep
          )
          : data.metaData.docId,
      issuedFrom:
        data.metaData.issuedFrom && data.metaData.issuedFrom.descEng
          ? getTValue(
            i18n,
            data.metaData.issuedFrom.descEng,
            data.metaData.issuedFrom.descNep
          )
          : data.metaData.issuedFrom,
      issuedDateBs:
        data.metaData.issuedDateBs && data.metaData.issuedDateBs.descEng
          ? getTValue(
            i18n,
            data.metaData.issuedDateBs.descEng,
            data.metaData.issuedDateBs.descNep
          )
          : data.metaData.issuedDateBs,
      issuedDate:
        data.metaData.issuedDate && data.metaData.issuedDate.descEng
          ? getTValue(
            i18n,
            data.metaData.issuedDate.descEng,
            data.metaData.issuedDate.descNep
          )
          : data.metaData.issuedDate,
    }
    : {
      docId: t("documentId"),
      issuedFrom: t("issuedDistrict"),
      issuedDateBs: t("dateInBs"),
      issuedDate: t("dateInAd"),
    };

  return (
    <>
      <h4 className="p-col-12 p-md-12">
        <p className="section-title">{t(data.documentTypeDesc)}</p>
      </h4>
      {metaData.docId && (
        <div className="p-field p-col-12 p-md-3 stick-right">
          <label className="p-col-12 p-md-12">{metaData.docId}</label>
          <InputText
            value={data.docId}
            onChange={(e) => {
              dispatch(
                setDocumentValue({
                  code: data.documentTypeId,
                  key: "docId",
                  value: e.target.value,
                })
              );
            }}
            placeholder={metaData.docId}
          />
        </div>
      )}
      {metaData.issuedFrom && (
        <div className="p-field p-col-12 p-md-3 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="issuedDistrict">
            {metaData.issuedFrom}
          </label>
          <InputText
            value={data.issuedFrom}
            onChange={(e) => {
              dispatch(
                setDocumentValue({
                  code: data.documentTypeId,
                  key: "issuedFrom",
                  value: e.target.value,
                })
              );
            }}
            placeholder={t("issuedDistrict")}
          />
        </div>
      )}
      {metaData.issuedDate &&
        <AdBsDatePicker
          label={t("issuedDate")}
          bsDate={data.issuedDateBs}
          adDate={data.issuedDate}
          onChange={(issuedDate, issuedDateBs, extra) => {
            dispatch(
              setDocumentValue({ code: data.documentTypeId, key: "issuedDateBs", issuedDateBs })
            );
            dispatch(setDocumentValue({
              code: data.documentTypeId,
              key: "issuedDate",
              value: issuedDate,
            }))
          }} />
      }
      {/* {metaData.issuedDateBs && (
        <div className="p-field p-col-12 p-md-3 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="issuedDateBs">
            {metaData.issuedDateBs}
          </label>
          <span className="p-input-icon-right">
            <i className="pi pi-calendar icon-front" />
            <NepaliDatePicker2
              inputClassName="form-control p-inputtext p-component p-filled"
              placeholder={t("dateInBs")}
              onChange={(value) => {
                dispatch(
                  setDocumentValue({
                    code: data.documentTypeId,
                    key: "issuedDateBs",
                    value: value,
                  })
                );

                const checkDate = isValidDate(value);
                if (checkDate) {
                  const convertedBsDate = bsToAd(value);
                  dispatch(
                    setDocumentValue({
                      code: data.documentTypeId,
                      key: "issuedDate",
                      value: new Date(convertedBsDate),
                    })
                  );
                }
              }}
              value={data.issuedDateBs}
            />
          </span>
        </div>
      )}
      {metaData.issuedDate && (
        <div className="p-field p-col-12 p-md-3 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="issuedDate">
            {metaData.issuedDate}
          </label>
          <span className="p-input-icon-right">
            <i className="pi pi-calendar icon-front" />
            <CalendarAD
              mask="9999-99-99"
              value={data.issuedDate}
              onChange={(e) => {
                if (!e.value) { return; }
                try {

                  const convertedAdDate = adToBs(
                    new Date(
                      e.value.getTime() - e.value.getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .split("T")[0]
                  );
                  dispatch(
                    setDocumentValue({
                      code: data.documentTypeId,
                      key: "issuedDateBs",
                      value: convertedAdDate,
                    })
                  );
                  dispatch(
                    setDocumentValue({
                      code: data.documentTypeId,
                      key: "issuedDate",
                      value: new Date(e.value + "EDT"),
                    })
                  );
                } catch (e) {
                  alert("Date out of availability");
                  console.log(e);
                }
              }}
              placeholder={t("dateInAd")}
              monthNavigator
              yearNavigator
              yearRange={"1900 : " + new Date().getFullYear()}
              dateFormat="yy-mm-dd"
            />
          </span>
        </div>
      )} */}
      {data.errorDesc && <span style={{ color: "red" }}>{data.errorDesc}</span>}
    </>
  );
}

export default PersonalDetails;
